import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { ConsolidatedEquipmentAvailabilityService } from 'src/app/services/preliminaries/consolidated-equipment-availability.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-consolidated-availability-report',
  templateUrl: './consolidated-availability-report.component.html',
  styleUrls: ['./consolidated-availability-report.component.scss'],
  standalone: false
})
export class ConsolidatedAvailabilityReportComponent implements OnInit {

  private readonly consolidatedEquipmentAvailabilityService = inject(ConsolidatedEquipmentAvailabilityService);
  private readonly config = inject(DynamicDialogConfig);
  private readonly toastHandlerService = inject(ToastHandlerService);

  articleId: number = 0;
  listReports: CustomTableReport[] = [];
  subscription: Subscription;

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$.subscribe(async (inputs: any) => {
      this.articleId = inputs.articleId;
    });
    await this.getConsolidatedReport();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async getConsolidatedReport() {
    try {
      const response = await firstValueFrom(
        this.consolidatedEquipmentAvailabilityService.getConsolidatedEquipmentAvailabilityReport(this.articleId)
      );
      this.listReports = response;
    } catch (error) {
      console.error("Error al cargar el consolidado", error);
    }
  }

  printReport() {
    if (this.listReports.length === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No se encontraron datos para imprimir.',
      );
      return;
    }
    window.print();
  }
}
